export const enum SNACK_ACTION {
    ERROR = 'snackbar/error',
    WARNING = 'snackbar/warning',
    SUCCESS = 'snackbar/success',
    CLEAR = 'snackbar/clear',
}

export const enum SNACK_TYPE {
    ERROR = 'error',
    WARNING = 'warning',
    SUCCESS = 'success',
}

export interface SnackBarState {
    on: boolean;
    type: SNACK_TYPE;
    message: string;
}

const state: SnackBarState = {
  on: false,
  type: SNACK_TYPE.SUCCESS,
  message: '',
};

const actions = {
  // eslint-disable-next-line
  error: ({ commit }: any, message: string) => {
    commit('error', message);
  },

  // eslint-disable-next-line
  warning: ({ commit }: any, message: string) => {
    commit('warning', message);
  },

  // eslint-disable-next-line
  success: ({ commit }: any, message: string) => {
    commit('success', message);
  },

  // eslint-disable-next-line
  clear: ({ commit }: any) => {
    commit('clear');
  },
};

const mutations = {
  error(newState: SnackBarState, message: string) {
    newState.type = SNACK_TYPE.ERROR;
    newState.message = message;
    newState.on = true;
  },

  warning(newState: SnackBarState, message: string) {
    newState.type = SNACK_TYPE.WARNING;
    newState.message = message;
    newState.on = true;
  },

  success(newState: SnackBarState, message: string) {
    newState.type = SNACK_TYPE.SUCCESS;
    newState.message = message;
    newState.on = true;
  },

  clear(newState: SnackBarState) {
    newState.on = false;
  },
};

export const snackbar = {
  namespaced: true,
  state,
  actions,
  mutations,
};
